const generalDataFaqs = [
    {
        id:"1",
        question: "Why Should I Choose M Power Moving Services?", 
        answer: "M Power Moving Services is Cudahy Wisconsin most trusted and reliable moving and storage company. We provide seamless, safe, and efficient moving solutions with competitive pricing and exceptional customer service that set us apart from the rest."
    },
    {
        id:"2",
        question:"Is M Power Moving Services Licensed?",
        answer:"Yes, we are a fully licensed and insured company , and compliant with WIDOT and USDOT regulations and standards."
    },
    {
        id:"3",
        question:"What Is the Best Day of the Week to Move?",
        answer:"Sunday is the ideal moving day due to lighter traffic and better parking availability. However, if you live in a doorman building that restricts weekend moves, Tuesday or Wednesday are great alternatives, as fewer people tend to move on these days."
    },
    {
        id:"4",
        question:"How Far in Advance Should I Plan and Book My Move?",
        answer:"We recommend booking your move 2 to 4 weeks in advance, depending on the size and complexity of your relocation."
    },
    {
        id:"5",
        question:"Do You Offer Long-Distance Moving Across the USA?",
        answer:"Yes! We provide smooth and hassle-free cross-country moves to and from any location in the United States, just as efficiently as our local moves within Cudahy Wisconsin."
    },
    {
        id:"6",
        question:"How Can the Weather Affect My Move?",
        answer:"Weather conditions such as heavy rain or snow may create additional challenges, but our expert movers are fully trained and equipped to handle all weather conditions. We come prepared with shovels, plastic covers, and all necessary tools to ensure a smooth move, no matter the forecast."
    },{
        id:"7",
        question:"What Is the Best Time of Day to Schedule My Move?",
        answer:"We recommend starting your move in the morning, between 7-9 AM, if your schedule allows. An early start ensures a smoother process and lets you settle into your new home as soon as possible!"
    },

]

export default generalDataFaqs;